/**
 * Created by Tiger on 24/02/2022.
 */

import onChangeLanguage from './language';
import {
  onDeleteConfig, onNewConfig, onRefreshAliHostsList, onRefreshConfigList, onRefreshProducts, onUpdateConfig,
} from './config';
import {onDeleteDevice, onDeviceList, onRefreshNotPrivateDevices, onUpdateDevices} from './device';
import {onChangeTab} from './header';


const actions = {
  onChangeTab,
  onChangeLanguage,
  onRefreshConfigList,
  onRefreshAliHostsList,
  onNewConfig,
  onUpdateConfig,
  onDeleteConfig,
  onDeviceList,
  onUpdateDevices,
  onDeleteDevice,
  onRefreshProducts,
  onRefreshNotPrivateDevices,
};

export default actions;